import React from 'react';
import { useSelector } from 'react-redux';
import RadioChip from './RadioChip';

const RadioChipContainer = ({ labels, type }) => {
    const profile = useSelector(state => state.profile.profile);
    const preferenceFilters = useSelector(state => state.profile.preferenceFilters);

    const assignStyle = (name) => {
        if (type === 'gender') {
            if (profile.gender === name) {
                return { margin: '20px 5px', backgroundColor: '#41004C', color: '#fff' };
            }
            else{
                return { margin: '20px 5px' };
            }
        }
        else if (type === 'preferenceFilters') {
            if (preferenceFilters !== null) {
                if (preferenceFilters.campus === name) {
                    return { margin: '20px 5px', backgroundColor: '#41004C', color: '#fff' };
                }
                else{
                    return { margin: '20px 5px' };
                }
            }
        }
        else{
            if (profile.virtue[type] === name) {
                return { margin: '20px 5px', backgroundColor: '#41004C', color: '#fff' };
            }
            else{
                return { margin: '20px 5px' };
            }
        }
    }

    var chips = labels.map((name) => {
        return <RadioChip key={name} name={name} chipStyles={assignStyle(name)} type={type} />
    });

    return (
        <div className="chip-container">
            {chips}
        </div>
    );
};

export default RadioChipContainer;